var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserSetup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#fff;stroke-miterlimit:10;stroke-width:20px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ARTBOARD_2",
    "data-name": "ARTBOARD 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M708.32,981.12c0-219.19-188.19-230.26-188.19-230.26l-293.41.51C196.9,755,43.55,783.24,43.55,981.12Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 375.94,
    cy: 481.87,
    r: 188.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M998.91,274.89A175.55,175.55,0,0,0,972,206.07l27.25-27.25L953,132.54l-26.54,26.54a175,175,0,0,0-67.73-28.87V98.88H793.23V130a175.14,175.14,0,0,0-68.86,28.89l-26.3-26.3-46.28,46.28,26.92,26.92a175.28,175.28,0,0,0-27.16,69.15H616v65.45h37.42a175.29,175.29,0,0,0,29.87,66.43l-29.19,28.38,46.29,46.28,30.26-30.26a174.85,174.85,0,0,0,61.9,24.72v38.72H858V475.79a175.29,175.29,0,0,0,64.1-26l27.06,29.58,46.28-46.28L968,405.73a175.12,175.12,0,0,0,29.22-65.39h39.24V274.89ZM826.2,406.94a100.2,100.2,0,1,1,100.19-100.2A100.2,100.2,0,0,1,826.2,406.94Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSetup);
export default __webpack_public_path__ + "static/media/user_setup.f4096bb8c0224fed71b69b2c7b0f359c.svg";
export { ForwardRef as ReactComponent };